import Vue from 'vue';
import Vuex from 'vuex';
import RootState from './types/IRootState';
import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  strict: true,
  modules,
});
